import { render, staticRenderFns } from "./document-related.vue?vue&type=template&id=267e42ad&lang=pug&"
import script from "./document-related.vue?vue&type=script&lang=ts&"
export * from "./document-related.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports